<template>
	<!-- Modal markup -->
	<div class="modal fade" tabindex="-1" role="dialog" v-bind:class="{show: cartModalVisible}">
		<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title"><i data-feather="check-circle" class="text-success"></i>&nbsp;{{lastAddedProductName}} добавлен в корзину</h5>
					<button type="button" class="close" aria-label="Close" v-on:click="closeCartModal">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="row" v-if="cartProducts.length > 0">
						<div class="col-xl-9 col-md-8 cart-list">
							<h2 class="h6 d-flex flex-wrap justify-content-between align-items-center px-4 py-3 bg-secondary">
								<span>Товаров в корзине - {{cartProducts.length}}</span>
								<span v-if="checkedItemCount > 0">
									Выбрано элементов - {{checkedItemCount}}. <button class="btn btn-secondary btn-sm" v-on:click="removeCheckedItems">Удалить выбранное</button>
								</span>
							</h2>
							<!-- Item-->
							<cart-item v-for="(product, index) in cartProducts.slice().reverse()"
									   v-bind:product="product"
									   v-bind:edit-visible-always="true"
									   v-bind:is-edit-visible="true"
									   v-bind:key="`product__${index}`">
							</cart-item>
						</div>
						<!-- Sidebar-->
						<div class="col-xl-3 col-md-4 pt-3 pt-md-0">
							<h2 class="h6 px-4 py-3 bg-secondary text-center">Общая сумма</h2>
							<div class="h3 font-weight-semibold text-center py-3">{{totalSum}} ₽</div>
							<hr>
							<button class="btn btn-secondary btn-block mb-4" type="button" v-on:click="closeCartModal">
								<i class="fa fa-chevron-left mr-2" aria-hidden="true"></i>Продолжить покупки
							</button>
							<a class="btn btn-primary btn-block" href="/Order/Checkout">
								<i class="fa fa-credit-card mr-2" aria-hidden="true"></i>Оформить заказ
							</a>
						</div>
					</div>
					<div class="d-flex justify-content-center" v-else>
						<div class="jumbotron text-center">
							<h1>Корзина пустая!</h1>
							<p class="lead">Вы не выбрали ни одного товара.</p>
							<hr class="my-4">
							<p class="pb-3">Если у вас возникли вопросы, свяжитесь с администрацией магазина.</p>
							<a href="/Home/Contact" class="btn btn-primary" role="button">Контакты</a>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" v-on:click="closeCartModal">Закрыть</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { namespace, actions, getters } from "Cart/store/store";
	import { mapActions, mapGetters } from "vuex";
	import cartItemComponent from "Components/cartItemComponent";
	import { bus } from "Util/bus.js";

	export default {
		name: "cart-modal",
		data() {
			return {
				lastAddedProductName: null,
				cartModalVisible: false
			};
		},
		computed: {
			...mapGetters(namespace,
				{
					totalSum: getters.totalSum.name,
					cartProducts: getters.cartProducts.name,
					checkedItemCount: getters.checkedItemCount.name
				})
		},
		methods: {
			...mapActions(namespace,
				{
					addProductToCart: actions.addProductToCart.name,
					removeCheckedItems: actions.removeCheckedItems.name,
					removeProductFromCart: actions.removeProductFromCart.name
				}),
			productAdded(value) {
				this.cartModalVisible = true;
				this.lastAddedProductName = value;
			},
			closeCartModal() {
				this.cartModalVisible = false;
			}
		},
		components: {
			"cart-item": cartItemComponent
		},
		created() {
			bus.$on("productAdded", this.productAdded);
		}
	}
</script>